export async function getConfettiInstance(canvas?: HTMLCanvasElement) {
  if (canvas) {
    return new (await import("js-confetti")).default({
      canvas,
    });
  }

  return new (await import("js-confetti")).default();
}

export async function launchConfetti() {
  const instance = await getConfettiInstance();

  return instance.addConfetti();
}
